import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-faa024fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toPageTop" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ページトップへ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toPageTop && _ctx.toPageTop(...args))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toPageTop && _ctx.toPageTop(...args)), ["prevent"]), ["space","enter"])),
      class: "button-toPageTop"
    }, [
      _createElementVNode("a", null, [
        _hoisted_2,
        _createVNode(_component_DssIcon, { icon: 'pagetop-up' })
      ])
    ], 32)
  ]))
}